import { render, staticRenderFns } from "./MealTiming.vue?vue&type=template&id=3b41b926&scoped=true&"
import script from "./MealTiming.vue?vue&type=script&lang=js&"
export * from "./MealTiming.vue?vue&type=script&lang=js&"
import style0 from "./MealTiming.vue?vue&type=style&index=0&id=3b41b926&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b41b926",
  null
  
)

export default component.exports